import React from 'react'
import '/node_modules/bootstrap/dist/css/bootstrap.min.css'

import PageRoute from './Components/PageRoute'

const App = () => {
  return (
    <>
      <PageRoute />
    </>
  )
}

export default App